import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentMessage} from "../NfComponentMessage";

/**
 * Wiadomość, gdy komponent chce otrzymać aktualny stan wybranych rzeczy ze sklepu, do service workera
 */
export class GetShopChosen extends NfComponentMessage {
    public constructor(event?: MessageEvent<GetShopChosen>) {
        super(NfMessageType.GetShopChosen);
        if(NfMessage.isMessageEvent(event)) {
            Object.assign(this, event.data);
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.GetShopChosen] = (event) => {
    const message =  new GetShopChosen(event);
    return message;
}
